<template>
  <div class="bg">
    <div class="mask"></div>
    <div class="loading">
      <van-loading color="white"
                   style="margin:0 auto; padding:12px 0;"
                   size="60px" />
      <p>{{text}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: ''
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.bg {
  width: 100%;
  min-height: 100vh;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
.mask {
  position: fixed;
  z-index: 1000;
  background: rgba(83, 82, 82, 0.1);
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}

.loading {
  position: relative;
  z-index: 5000;
  width: 7.6em;
  min-height: 7.6em;
  top: 50%;
  left: 50%;
  background: rgba(83, 82, 82, 0.8);
  transform: translate(-50%, -50%);
  border-radius: 15px;
  color: #ffffff;
  font-size: 28px;
  text-align: center;
}

@keyframes mloading {
  from {
    transform: rotate3d(0, 0, 1, 0deg);
  }
  to {
    transform: rotate3d(0, 0, 1, 360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loading/loading.vue